import { render } from "./PayOutRequisites.vue?vue&type=template&id=d847e84a&ts=true"
import script from "./PayOutRequisites.vue?vue&type=script&lang=ts"
export * from "./PayOutRequisites.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__